// extracted by mini-css-extract-plugin
export default {"inputWrapper":"styles_inputWrapper__hbMwI","inputWrapperReverse":"styles_inputWrapperReverse__+jzHt","button":"styles_button__UG4F9","error":"styles_error__ZuLyW"};